module.exports = __webpack_public_path__ + "static/img/renter_bg2.c9966f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rule/renter_bg2.jpg
// module id = vda4
// module chunks = 1